import { api } from './client';

export type MessageType = 'OPS' | 'RENEWAL' | 'UPGRADE' | 'ALERT';
export type MessageLevel = 'HIGH' | 'MEDIUM' | 'LOW';

export interface InboxMessage {
  id: string;
  type: MessageType;
  title: string;
  content: string;
  level: MessageLevel;
  read: boolean;
  createdAt: string;
  actionPath?: string;
}

type InboxScope = 'platform' | 'tenant';

function resolveInboxBase(scope: InboxScope = 'tenant') {
  return scope === 'platform' ? '/api/platform/inbox' : '/api/inbox';
}

export const inboxApi = {
  // 获取我的站内信
  getMyMessages: (scope?: InboxScope) =>
    api.get<InboxMessage[]>(`${resolveInboxBase(scope)}/my`),

  // 标记消息为已读
  markAsRead: (messageId: string, scope?: InboxScope) =>
    api.post(`${resolveInboxBase(scope)}/${messageId}/read`, {}),

  // 标记所有消息为已读
  markAllAsRead: (scope?: InboxScope) =>
    api.post(`${resolveInboxBase(scope)}/read-all`, {}),

  // 创建消息（用于测试）
  createMessage: (
    data: {
      type: MessageType;
      title: string;
      content: string;
      level: MessageLevel;
      actionPath?: string;
    },
    scope?: InboxScope,
  ) => api.post<InboxMessage>(resolveInboxBase(scope), data),
};
